const appOrigin =
  typeof window !== 'undefined'
    ? window.location.origin
    : 'https://search-engine-optimisation.geneaiqa.thermofisher.com';

export const environment = {
  production: false,
  playwrightAuthBypass: false,
  apiUrl: 'https://search-engine-optimisation.aad-eks-nae-geneai-qa.geneaiqa.thermofisher.com/api',
  msalConfig: {
    auth: {
      clientId: 'a6da0d8a-a5eb-45d9-adbf-1146b8c04c69',
      authority: 'https://login.microsoftonline.com/b67d722d-aa8a-4777-a169-ebeb7a6a3b67',
      redirectUri: `${appOrigin}/auth`,
      postLogoutRedirectUri: `${appOrigin}/`,
    }
  },
  seoAdminsGroupId: '1eadfb09-a5c8-46db-89d0-2d7bd4d9f57a',
  featureFlags: {
    showDateFilter: false,
    showGeoAeoPage: true,
    showAdminConsolePage: true,
    showUsageMetricsPage: true,
    showUrlTaxonomy: true
  }
};
